import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Reveal } from "../components/ui/reveal";
import { cn } from "../lib/utils";
const VARIANTS = ["left", "center", "right"];
const ALIGNMENT_CLASSES = {
    left: "items-start justify-start text-left",
    center: "items-center text-center ",
    right: "items-end justify-end text-right",
};
const CONTENT_WIDTH_CLASSES = {
    left: "w-[clamp(200px,100%,510px)]",
    center: "w-[clamp(200px,100%,700px)]",
    right: "w-[clamp(200px,100%,510px)]",
};
export function HeroBlock({ data, className, children, titleId, delayBase = 0.1, ...props }) {
    const { eyebrow, title, description } = data;
    const variant = data.variant ?? "left";
    const step = 0.12;
    return (_jsx("section", { className: cn("flex flex-col w-full px-40", "@max-[1200px]:px-[clamp(48px,10cqw,120px)]", "@max-[1160px]:h-auto @max-[1160px]:px-m-gutter", ALIGNMENT_CLASSES[variant], className), "aria-labelledby": titleId, ...props, children: _jsxs("div", { className: cn("flex flex-col items-start gap-[22px]", "@max-[900px]:mx-auto @max-[900px]:items-center @max-[900px]:text-center", ALIGNMENT_CLASSES[variant], CONTENT_WIDTH_CLASSES[variant]), children: [eyebrow ? (_jsx(Reveal, { delay: delayBase, children: _jsx("p", { "data-hero-eyebrow": true, className: "type-eyebrow-lg m-0", children: eyebrow }) })) : null, _jsx(Reveal, { delay: delayBase + step, children: _jsx("h1", { "data-hero-title": true, id: titleId, className: "m-0 font-display text-[96px] font-light leading-[1.04] tracking-[-0.02em] text-brand-blue @max-[900px]:text-[clamp(52px,13.5cqw,64px)]", children: title }) }), description ? (_jsx(Reveal, { delay: delayBase + step * 2, children: _jsx("p", { "data-hero-description": true, className: "m-0 w-full font-sans text-xl font-light leading-[1.55] text-foreground @max-[900px]:text-lg", children: description }) })) : null, children ? (_jsx(Reveal, { delay: delayBase + step * 3, children: children })) : null] }) }));
}
export function heroFromBlock(block) {
    const scalars = block.scalars ?? {};
    const variant = scalars.variant;
    return {
        eyebrow: scalars.eyebrow?.trim() || undefined,
        title: scalars.heading || scalars.title || "",
        description: scalars.subheading || scalars.description || undefined,
        variant: VARIANTS.includes(variant) ? variant : "left",
    };
}
export const heroBlockEntry = {
    Component: HeroBlock,
    fromBlock: heroFromBlock,
};
//# sourceMappingURL=hero.js.map